import { render } from "./Team.vue?vue&type=template&id=93864a42&scoped=true&ts=true"
import script from "./Team.vue?vue&type=script&lang=ts"
export * from "./Team.vue?vue&type=script&lang=ts"

import "./Team.vue?vue&type=style&index=0&id=93864a42&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93864a42"]])

export default __exports__